import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { LargeImageNavigatorComponent } from './large-image-navigator.component';
import { ReaderModalModule } from '@mhe/reader/components/modals/modal.module';
import { LargeImageNavigatorModule as LargeImageNavigatorLibraryModule } from '@mhe/ngx-large-image-navigator';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    TranslateModule,
    ReaderModalModule,
    LargeImageNavigatorLibraryModule,
  ],
  declarations: [LargeImageNavigatorComponent],
  exports: [LargeImageNavigatorComponent],
})
export class LargeImageNavigatorModule {}
